import Papa from 'papaparse';

export const parseProjectsFromCSV = async (csvFile) => {
  return new Promise((resolve, reject) => {
    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const projects = results.data.map((row, index) => ({
          id: index + 1,
          sn: row.SN || row['SN'],
          name: (row['Project Name'] || row['Project Name'] || '').trim(),
          contractNo: (row['Contract No'] || row['Contract No'] || '').trim(),
          startDate: (row['Start Date'] || row['Start Date'] || '').trim(),
          endDate: (row['End Date'] || row['End Date'] || '').trim(),
          budget: (row.Budget || row.Budget || '').trim(),
          type: (row.Type || row.Type || '').trim(),
          comments: (row.Comments || row.Comments || '').trim(),
          photoDirectory: (row['Photo Directory'] || row.PhotoDirectory || '').trim(),
        })).filter(project => project.name); // Filter out empty rows
        resolve(projects);
      },
      error: (error) => {
        reject(error);
      }
    });
  });
};

export const loadProjects = async () => {
  try {
    const baseUrl = process.env.PUBLIC_URL || '';
    const csvPath = `${baseUrl}/Project List.csv`;
    const response = await fetch(csvPath);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch CSV: ${response.status} ${response.statusText}`);
    }
    
    const csvText = await response.text();
    const projects = await parseProjectsFromCSV(csvText);
    return projects;
  } catch (error) {
    console.error('Error loading projects:', error);
    return [];
  }
};

